import React from 'react';

const ErrorDisplay: React.FC<{ errors: string[] }> = ({ errors }) => (
  <div>
    {errors.map((err, index) => (
      <p key={index}>{err}</p>
    ))}
  </div>
);

export default ErrorDisplay;
